import { t } from '@/utils/i18n'
import iconCard from '@/assets/img/icon-card@2x.webp'
import iconCard2 from '@/assets/img/icon-card2@2x.webp'
import iconCard3 from '@/assets/img/icon-card3@2x.webp'
import iconCard4 from '@/assets/img/icon-card4@2x.webp'

const langClass = {
  zh: 'zhlang',
  en: 'enlang',
  ar: 'arlang',
  tr: 'trlang',
};

const langFontClass = {
  en: 'enfont',
  ar: 'arfont',
  tr: 'trfont',
};

const sourceList = {
  hybrid: '0', // 本项目
  hoby: '1', // 旧项目
  native: '2', // 原生app 跳转进入
}

const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
const DATE_FORMAT = 'YYYY-MM-DD';


const getGuildDataTitleList = (t: (key: string) => string) => [
  {
    period: 1,
    title: t('当前期间'),
    subtitle: t('当期收入'),
    icon: iconCard,
    style: 'style1',
  },
  {
    period: 2,
    title: t('末期'),
    subtitle: t('上期收入'),
    icon: iconCard,
    style: 'style1',
  },
  {
    period: 3,
    title: t('今日'),
    subtitle: t('今日收入'),
    icon: iconCard2,
    style: 'style2',
  },
  {
    period: 4,
    title: t('昨日'),
    subtitle: t('昨日收入'),
    icon: iconCard2,
    style: 'style2',
  },
  {
    period: 5,
    title: t('本周'),
    subtitle: t('本周收入'),
    icon: iconCard3,
    style: 'style3',
  },
  {
    period: 6,
    title: t('上周'),
    subtitle: t('上周收入'),
    icon: iconCard3,
    style: 'style3',
  },
  {
    period: 7,
    title: t('本月'),
    subtitle: t('本月收入'),
    icon: iconCard4,
    style: 'style4',
  },
  {
    period: 8,
    title: t('上月'),
    subtitle: t('上月收入'),
    icon: iconCard4,
    style: 'style4',
  }
]

// 充值需要过滤的国家列表: 摩洛哥,阿尔及利亚,埃及,也门
const FILTER_COUNTRY_LIST = [34, 40, 42, 15]


export default {
  REQUEST_EXPIRED: t('请求已过期'),
  DATE_TIME_FORMAT,
  DATE_FORMAT,
  langClass,
  langFontClass,
  sourceList,
  FILTER_COUNTRY_LIST,
  getGuildDataTitleList
};
